export enum Platform {
  WEB = 'web',
  IOS = 'ios',
  ANDROID = 'android',
}

export const PLATFORM_LABELS: Record<string, string> = {
  [Platform.WEB]: 'Web',
  [Platform.IOS]: 'iOS',
  [Platform.ANDROID]: 'Android',
};

/**
 * Order in which platforms are listed and auto-expanded — the earliest present
 * platform wins as the default-expanded group. Drives {@link sortPlatformKeys}
 * and single-platform preselection.
 */
export const PLATFORM_PRIORITY: Platform[] = [Platform.WEB, Platform.IOS, Platform.ANDROID];

export enum ReleaseNoteProduct {
  TxcAccess = 'txc-access',
  OpoAccess = 'opo-access',
  Nexus = 'nexus',
  Live = 'live',
}

export type ReleaseNoteProductConfig = {
  label: string;
  platforms: Platform[];
};

export const RELEASE_NOTE_PRODUCT_CONFIG: Record<ReleaseNoteProduct, ReleaseNoteProductConfig> = {
  [ReleaseNoteProduct.TxcAccess]: { label: 'TXC Access', platforms: [Platform.WEB, Platform.IOS, Platform.ANDROID] },
  [ReleaseNoteProduct.OpoAccess]: { label: 'OPO Access', platforms: [Platform.WEB, Platform.IOS, Platform.ANDROID] },
  [ReleaseNoteProduct.Nexus]: { label: 'Nexus', platforms: [Platform.IOS] },
  [ReleaseNoteProduct.Live]: { label: 'Live', platforms: [Platform.IOS] },
};

export const RELEASE_NOTE_PRODUCT_LABELS = Object.fromEntries(
  Object.entries(RELEASE_NOTE_PRODUCT_CONFIG).map(([product, { label }]) => [product, label]),
) as Record<ReleaseNoteProduct, string>;
